import { render, staticRenderFns } from "./barchartTwo.vue?vue&type=template&id=1df6a094"
import script from "./barchartTwo.vue?vue&type=script&lang=js"
export * from "./barchartTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports